import { graphql } from "relay-runtime"

export const chSavePreventionProgramEngagementsMutation = graphql`
  mutation chSavePreventionProgramEngagementsMutation(
    $input: Ch_savePreventionProgramEngagementsInput!
    $addConnections: [ID!]!
  ) {
    savePreventionProgramEngagements: ch_savePreventionProgramEngagements(input: $input) {
      patientPreventionProgramOutput @appendNode(connections: $addConnections, edgeTypeName: "PreventionProgramsEdge") {
        ...PatientPreventionProgramOutputFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
